import { useTheme as useThemeBase } from 'emotion-theming';
import { ITheme } from './theme';

export const useTheme = () => useThemeBase<ITheme>();
